import React from 'react';

import PageTitleAndFilters from 'components/PageTitleAndFilters';
import PickScheduleChooseLayoutButtonGroup from 'components/PickScheduleChooseLayoutButtonGroup';
import MultipleActiveTableRowsExistGate from 'components/MultipleActiveTableRowsExistGate';
import VirtualizedTableBulkEditButton from 'components/VirtualizedTableBulkEditButton';

import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

interface Props {
    MessageComponent?: React.ReactElement;
}

const PickSchedulePageTitleAndFiltersComponent = (
    props: Props
): React.ReactElement => {
    const { MessageComponent } = props;

    return (
        <PageTitleAndFilters
            title="Pick Schedule"
            FirstActionButton={
                <MultipleActiveTableRowsExistGate>
                    <VirtualizedTableBulkEditButton
                        requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                    />
                </MultipleActiveTableRowsExistGate>
            }
            SecondActionButton={<PickScheduleChooseLayoutButtonGroup />}
            currentEntity
            currentSeason
            pickType
            pickTypeMultiple
            variety
            varietyMultiple
            group
            groupMultiple
            groupIncludeUnassignedOption
            entity
            entityMultiple
            MessageComponent={MessageComponent}
        />
    );
};

export default PickSchedulePageTitleAndFiltersComponent;
